<app-progress-spinner *ngIf="!showoptCPlcAnalysis"></app-progress-spinner>
<div class="container" style="margin-bottom: 20px;">
  
        <div class="label-header">
          <label class="label-headercolor">Option C </label>
      </div>
     
        <ag-grid-angular style="width: 100%; height: 100%;"
        class="ag-theme-alpine"
        [headerHeight]="optCheaderHeight"
        [suppressRowTransform]="true"
        [getRowStyle]="getRowStyle"
        [rowClassRules]="optCrowClassRules"
        [rowHeight]="optCRowHeight"
        [rowStyle]="rowStyle"
        [rowData]="optCRowData"
        [columnDefs]="optCColumnDefs"
        [defaultColDef]="defaultColDef"
        [autoGroupColumnDef]="autoGroupoptCCostColumnDef"
        [groupDefaultExpanded]="groupDefaultExpanded"
        [suppressAggFuncInHeader]="true"
        [enableBrowserTooltips]="true"
        [domLayout]="domLayout"
        (gridReady)="onoptCGridReady($event)"
        (gridSizeChanged)="onoptCGridSizeChanged($event)"

        (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
    >
    
    </ag-grid-angular>

    <div class="row">
      <div class="offset-4 col-md-8">
          <div class="buttonStyle">
            
            <button class="button button--small" (click)="onClickBack()">Back</button>&nbsp;
          </div>
      </div>
  </div>
    </div>